module.exports = __webpack_public_path__ + "img/about4.029ef04f.png";